/**
 * Duck type the given value to determine if this is an Error or a descendent of Error.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties#detection_table
 */
export const isErrorLike = (value) => {
    if (typeof value === 'object') {
        /* Note that while .hasOwnProperty('message') will work for instances of `Error`, it will fail
        for instances of classes that extend `Error` (i.e., custom Errors of the form
        `MyError extends Error`). */
        return (typeof value.message !== 'undefined' && typeof value.stack !== 'undefined');
    }
    return false;
};
//# sourceMappingURL=utils.js.map